import {
  vMinLength,
  vNonEmptyString,
  vObject,
  vOptional,
  type vOutput,
  vPhoneExt,
  vPhoneNumber,
  vPipe,
  vString,
} from '../validation/index.ts'

export const emergencyContactSchema = vObject({
  name: vNonEmptyString(),
  phone: vPipe(vPhoneNumber(), vMinLength(1)),
  phoneExt: vOptional(vPhoneExt()),
  contractNumber: vOptional(vString()),
})

export type EmergencyContactDto = vOutput<typeof emergencyContactSchema>
